var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDotsFilled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Component_192_1",
    "data-name": "Component 192 \\u2013 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 31.39,
    height: 32,
    viewBox: "0 0 31.39 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_2213",
    "data-name": "Path 2213",
    d: "M4.469,0A4.163,4.163,0,1,0,8.633,4.163,4.164,4.164,0,0,0,4.469,0Zm0,7.327A3.164,3.164,0,1,1,7.633,4.164,3.168,3.168,0,0,1,4.469,7.327Z",
    transform: "translate(-0.305)",
    fill: "#414752"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2214",
    "data-name": "Path 2214",
    d: "M11.836,4.164A4.164,4.164,0,1,0,16,0,4.164,4.164,0,0,0,11.836,4.164Zm7.328,0A3.164,3.164,0,1,1,16,1,3.168,3.168,0,0,1,19.164,4.164Z",
    transform: "translate(-0.305)",
    fill: "#414752"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2215",
    "data-name": "Path 2215",
    d: "M27.531,0a4.164,4.164,0,1,0,4.164,4.164A4.164,4.164,0,0,0,27.531,0Zm0,7.327a3.164,3.164,0,1,1,3.164-3.163A3.167,3.167,0,0,1,27.531,7.327Z",
    transform: "translate(-0.305)",
    fill: "#414752"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2216",
    "data-name": "Path 2216",
    d: "M4.469,11.836A4.164,4.164,0,1,0,8.633,16a4.164,4.164,0,0,0-4.164-4.164Zm0,7.328A3.164,3.164,0,1,1,7.633,16,3.168,3.168,0,0,1,4.469,19.164Z",
    transform: "translate(-0.305)",
    fill: "#414752"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2217",
    "data-name": "Path 2217",
    d: "M16,11.836A4.164,4.164,0,1,0,20.164,16,4.164,4.164,0,0,0,16,11.836Zm0,7.328A3.164,3.164,0,1,1,19.164,16,3.167,3.167,0,0,1,16,19.164Z",
    transform: "translate(-0.305)",
    fill: "#414752"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2218",
    "data-name": "Path 2218",
    d: "M27.531,11.836A4.164,4.164,0,1,0,31.694,16,4.164,4.164,0,0,0,27.531,11.836Zm0,7.328A3.164,3.164,0,1,1,30.695,16,3.167,3.167,0,0,1,27.531,19.164Z",
    transform: "translate(-0.305)",
    fill: "#414752"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2219",
    "data-name": "Path 2219",
    d: "M4.469,23.673a4.163,4.163,0,1,0,4.164,4.163,4.164,4.164,0,0,0-4.164-4.163Zm0,7.327a3.164,3.164,0,1,1,3.164-3.164A3.168,3.168,0,0,1,4.469,31Z",
    transform: "translate(-0.305)",
    fill: "#414752"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2220",
    "data-name": "Path 2220",
    d: "M16,23.673a4.163,4.163,0,1,0,4.164,4.163A4.164,4.164,0,0,0,16,23.673ZM16,31a3.164,3.164,0,1,1,3.164-3.164A3.167,3.167,0,0,1,16,31Z",
    transform: "translate(-0.305)",
    fill: "#414752"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2221",
    "data-name": "Path 2221",
    d: "M27.531,23.673a4.163,4.163,0,1,0,4.164,4.163A4.164,4.164,0,0,0,27.531,23.673Zm0,7.327a3.164,3.164,0,1,1,3.164-3.164A3.167,3.167,0,0,1,27.531,31Z",
    transform: "translate(-0.305)",
    fill: "#414752"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_40",
    "data-name": "Ellipse 40",
    cx: 4,
    cy: 4,
    r: 4,
    fill: "#414752"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_41",
    "data-name": "Ellipse 41",
    cx: 4,
    cy: 4,
    r: 4,
    transform: "translate(12)",
    fill: "#414752"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_42",
    "data-name": "Ellipse 42",
    cx: 4,
    cy: 4,
    r: 4,
    transform: "translate(23)",
    fill: "#414752"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_43",
    "data-name": "Ellipse 43",
    cx: 4,
    cy: 4,
    r: 4,
    transform: "translate(0 12)",
    fill: "#414752"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_44",
    "data-name": "Ellipse 44",
    cx: 4,
    cy: 4,
    r: 4,
    transform: "translate(12 12)",
    fill: "#414752"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_45",
    "data-name": "Ellipse 45",
    cx: 4,
    cy: 4,
    r: 4,
    transform: "translate(23 12)",
    fill: "#414752"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_46",
    "data-name": "Ellipse 46",
    cx: 4,
    cy: 4,
    r: 4,
    transform: "translate(0 24)",
    fill: "#414752"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_47",
    "data-name": "Ellipse 47",
    cx: 4,
    cy: 4,
    r: 4,
    transform: "translate(12 24)",
    fill: "#414752"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_48",
    "data-name": "Ellipse 48",
    cx: 4,
    cy: 4,
    r: 4,
    transform: "translate(23 24)",
    fill: "#414752"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDotsFilled);
export default __webpack_public_path__ + "static/media/dotsFilled.948250c6ba952acb54035f7c4d477896.svg";
export { ForwardRef as ReactComponent };